<template>
	<div>
		<el-container style="position: absolute;left: 0;top: 0;bottom: 0;right: 0;overflow: hidden;">
			<el-header class="d-flex align-items-center" style="background: #fff;height:70px" ref="headers">
				<div class="h5 toplogobox text-light mb-0 mr-auto  u-f u-ac" style="margin-left: 33px;">
					<div class="logos u-f u-ac">
						<img src="../assets/imgs/logo2.png" alt="">
						<div class="logotext">正汉好医</div>
					</div>
					<div class="aside_icon_out">
						<i class="el-icon-s-fold aside_icon opicon" @click="togglemenu" style="color:#000"
							:class="{aside_on:isCollapse,aside_off:!isCollapse}"></i>
					</div>
				</div>
				<el-popover placement="bottom" width="200" trigger="hover">
					<div class="ewmtext">微信扫码提问题建议</div>
					<div class="top_ewm_b"><img src="../assets/imgs/kfma.jpg" alt=""></div>
					<div class="ewmtext2">小康</div>
					<div slot="reference" style="" class="u-f u-ac win_b">
						<img src="../assets/imgs/winxin.png" width="25" alt="">
						<span class="win_text" style="margin-left:8px">提问题建议</span>
					</div>
				</el-popover>
				<div class="line_w"></div>
				<div style="width:50px">
					<el-badge :value="noread" class="">
						<i class="el-icon-message xxicon" style="color:#000" @click="openxx"></i>
					</el-badge>
				</div>
				<div class="h_right">
					<el-menu :default-active="navBar.active" mode="horizontal" @select="handleSelect"
						background-color="#fff" text-color="#252631" active-text-color="#ffd04b">
						<!-- <el-menu-item :index="index | numToString" v-for="(item, index) in navBar.list" :key="index">
						{{ item.name }}</el-menu-item> -->
						<el-submenu index="100">
							<template slot="title">
								<el-avatar size="medium"
									:src="user.avatar? user.avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'">
								</el-avatar>
								<span class="" style="margin-left:10px">{{ user.username }}</span>
							</template>
							<!-- <el-menu-item index="100-1">修改</el-menu-item> -->
							<el-menu-item index="100-2">退出</el-menu-item>
						</el-submenu>
					</el-menu>
				</div>

			</el-header>
			<el-container style="height: 100%;overflow: auto;" class="">
				<!-- 侧边布局 -->
				<el-aside :width="asidewidth" style="" :style="'height:'+asideheight+'px'" v-if="slideMenus.length > 0"
					class="cebian">
					<el-menu :default-active="slideMenuActive" :collapse="isCollapse" collapse-transition
						@select="slideSelect" style="height: 100%;" background-color="#3B4368" text-color="#939ABF"
						active-text-color="#fff">
						<template v-for="(item, index) in slideMenus">
							<template v-if="item.child && item.child.length !== 0">
								<el-submenu :index="item.pathname" :key="index">
									<template slot="title">
										<!-- <span slot="title"> -->
										<i :class="item.icon" style="color:#939ABF"></i>
										<span slot="title">{{ item.name }}</span>
										<!-- </span> -->
									</template>
									<template v-for="(subItem, indexs) in item.child">
										<template v-if="subItem.child && subItem.child.length !== 0">
											<el-submenu :index="subItem.pathname" :key="indexs">
												<template slot="title">
													<span slot="title">
														<i :class="subItem.icon" style="color:#939ABF"></i>
														<span slot="title">{{ subItem.name }}</span>
													</span>
												</template>
												<el-menu-item v-for="(subItem2, indexs) in subItem.child" :key="indexs"
													:index="subItem2.pathname">
													<span slot="title">
														<i :class="subItem2.icon" style="color:#939ABF"></i>
														<span slot="title">{{ subItem2.name }}</span>
													</span>
												</el-menu-item>
											</el-submenu>
										</template>
										<template v-else>
											<el-menu-item :index="subItem.pathname" :key="indexs">
												<span slot="title">
													<i :class="subItem.icon" style="color:#939ABF"></i>
													<span slot="title">{{ subItem.name }}</span>
												</span>
											</el-menu-item>
										</template>
									</template>
								</el-submenu>
							</template>
							<template v-else>
								<el-menu-item :index="index | numToString" :key="index">
									<i :class="item.icon" style="color:#939ABF"></i>
									<span slot="title">{{ item.name }}</span>
								</el-menu-item>
							</template>
						</template>
					</el-menu>
				</el-aside>
				<!-- 主布局 -->
				<el-main class="" style=" position: relative; background-color: #edf0fa;" v-loading="loading">
					<!-- padding-bottom: 70px; -->
					<!-- 面包屑导航 -->
					<div class="" v-if="bran.length > 0"
						style="padding: 0px 26px;margin-bottom:20px;background-color: #edf0fa;">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item v-for="(item, index) in bran" :key="index" :to="{ path: item.path }">
								<span class="mbx_text">{{ item.title }}</span>
							</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<!-- 主内容 -->
					<div v-if="$route.meta.title==''" class="mian_view">
						<iframe src="https://bi.sanxc.com/share/fe19850d0acf48d1" frameborder="0" width="100%"
							height='100%'></iframe>
					</div>
					<div v-else style="height: calc(100% - 40px);">
						<keep-alive>
							<router-view v-if="$route.meta.keepAlive"></router-view>
						</keep-alive>
						<router-view v-if="!$route.meta.keepAlive"></router-view>
					</div>


					<el-backtop target=".el-main" :bottom="100">
						<div
							style="height: 100%;width: 100%; background-color: #f2f5f6;box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);text-align: center;line-height: 40px;color: #1989fa;">
							UP
						</div>
					</el-backtop>
				</el-main>
			</el-container>
		</el-container>
		<el-drawer title="" :visible.sync="drawer" direction="rtl" :show-close='false'>
			<template slot='title'>
				<div class="xx_b_title">系统消息 </div>
			</template>
			<div class="xx_out_b" ref="xxdrawer">
				<div class="l_item u-f u-ac" v-for="(l,index) in xx_list" :key="index">
					<div class="xx_cons">
						<div class="nr">{{l.Notification.notice_content}}</div>
						<div class="xx_time">{{l.create_time}}</div>
					</div>
					<div class="xicon">
						<i @click="delmsg(l.id,index,1)" class="el-icon-close closeicon"></i>
					</div>
				</div>
				<div class="qcbtn_b" :style="'width:'+qcbtnwidth+'px'">
					<div class="tbns" @click="delmsg(0,0,2)">清除所有</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import common from "@/common/mixins/common.js";
	import {
		mapState
	} from "vuex";
	export default {
		mixins: [common],
		provide() {
			return {
				layout: this,

			};
		},
		data() {
			return {
				bran: [],
				loading: false,
				isCollapse: false,
				asidewidth: '210px',
				asideheight: null,
				noread: '',
				xxdialogs: false,
				drawer: false,
				xx_list: [],
				qcbtnwidth: null,
				slideMenuActive: '',
				pagekeyword: ''

			};
		},
		created() {
			// 获取面包屑导航
			this.getRouterBran();
			// 初始化选中菜单
			this.__initNavBar();
		},
		watch: {
			$route(to, from) {
				this.navBar.list.forEach((item, index) => {
					let i = item.submenu.findIndex((v) => v.pathname === to.name);
					if (i !== -1) {
						this.navBar.active = index.toString();
						this.slideMenuActive = i.toString();
					}
				});

				// 本地存储
				localStorage.setItem(
					"navActive",
					JSON.stringify({
						top: this.navBar.active || "0",
						left: this.slideMenuActive || "0",
					})
				);
				this.getRouterBran();
			},
			'isCollapse'(n, o) {
				if (n) {
					this.asidewidth = 'auto'
				} else {
					this.asidewidth = '210px'
				}
			},
			'$openws.noread'(n, o) {
				this.noread = this.$openws.noread == 0 ? '' : this.$openws.noread
			}
		},
		computed: {
			...mapState({
				user: (state) => state.user.user,
				navBar: (state) => state.menu.navBar,
			}),
			slideMenus() {
				let item = this.navBar.list[this.navBar.active];
				return item ? item.submenu : [];
			},
		},
		mounted() {
			this.getxinxi()
			this.getxinlist()
			this.getheight()

		},

		methods: {

			getxinxi() {
				this.axios.post('/admin/SystemActivity/getLatest', {}, {
					token: true
				}).then(res => {
					this.noread = res.data.data.notification.no_read == 0 ? '' : res.data.data.notification.no_read
				})
			},
			getxinlist() {
				this.axios.post('/admin/SystemNotification/index', {
					page: 1,
					page_count: 100
				}, {
					token: true
				}).then(res => {
					this.xx_list = res.data.data.list
				})
			},
			getheight() {
				let that = this;
				that.$nextTick(() => {
					this.asideheight = window.innerHeight - 70
					window.onresize = () => {
						that.asideheight = window.innerHeight - 70
					};
				})
			},
			togglemenu() {
				this.isCollapse = !this.isCollapse

			},
			// 显示loading
			showLoading() {
				this.loading = true;
			},
			// 隐藏loading
			hideLoading() {
				this.loading = false;
			},
			__initNavBar() {
				let r = localStorage.getItem("navActive");
				if (r) {
					r = JSON.parse(r);
					this.navBar.active = r.top;
					this.slideMenuActive = r.left;
				} else {
					this.navBar.active = '0';
					this.slideMenuActive = '0';
				}
			},
			// 获取面包屑导航
			getRouterBran() {
				let b = this.$route.matched.filter((v) => v.name);
				let arr = [];
				b.forEach((v, k) => {
					// 过滤layout和index
					if (v.name === "index" || v.name === "layout") return;
					arr.push({
						name: v.name,
						path: v.path,
						title: v.meta.title,
					});
				});
				// if (arr.length > 0) {
				// 	arr.unshift({
				// 		name: "index",
				// 		path: "/index",
				// 		title: "首页",
				// 	});
				// }
				this.bran = arr;
			},
			handleSelect(key, keyPath) {
				if (key === "100-1") {
					return;
				}
				if (key === "100-2") {
					// 退出登录
					return this.logout();
				}
				this.navBar.active = key;
				// 默认选中跳转到当前激活
				this.slideMenuActive = "0";
				if (this.slideMenus.length > 0) {
					if (this.slideMenus[this.slideMenuActive].child.length > 0) {
						this.$router.push({
							name: this.slideMenus[this.slideMenuActive].child[0].pathname,
						});
						this.slideMenuActive =
							this.slideMenus[this.slideMenuActive].child[0].pathname;
					} else {
						this.$router.push({
							name: this.slideMenus[this.slideMenuActive].pathname,
						});
					}
				}
			},
			slideSelect(key, keyPath) {
				if (keyPath.length > 1) {
					this.slideMenuActive = key;
					
					let selectItem = this.getSelectItem(this.slideMenus, keyPath); //选中项
					let query = {};
					if(selectItem.pathname == 'iframe_iframe')query.url = selectItem.frontpath;

					return this.$router.push({
						name: key,
						query: query
					});
				}
				this.slideMenuActive = key;
				// 跳转到指定页面
				this.$router.push({
					name: this.slideMenus[key].pathname,
				});
			},
			// 退出登录
			logout() {
				this.axios
					.post(
						"/admin/logout", {}, {
							token: true,
							loading: true,
						}
					)
					.then((res) => {
						this.$message("退出成功");
						// 清除状态和存储
						this.$store.commit("logout");

						// 返回到登录页
						this.$router.push({
							name: "login",
						});
						this.$openws.ws.close();
						localStorage.removeItem('navActive')
					})
					.catch((err) => {
						// 清除状态和存储
						this.$store.commit("logout");
						// 返回到登录页
						this.$router.push({
							name: "login",
						});
						this.$openws.ws.close();
					});
			},
			delmsg(id, index, t) {

				this.$confirm(`确认删除${t==1?'此条消息':'全部消息'}吗？, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let ids = []
					if (t == 1) {
						ids = [id]
					} else {
						ids = ''
					}
					this.axios.post('/admin/pc/sys/delMsg', {
						id: ids,
						delType: t,
						sourceType: 1
					}, {
						token: true
					}).then(res => {
						if (res.data.code == 200) {
							this.$message.success('删除成功！')
							if (t == 1) {
								this.xx_list.splice(index, 1)
							} else {
								this.xx_list = []
							}
						} else {
							this.$message(res.data.msg)
						}
					})
				}).catch(() => {

				});

			},
			openxx() {

				this.drawer = true
				this.$nextTick(() => {
					this.qcbtnwidth = this.$refs.xxdrawer.offsetWidth
					window.onresize = () => {
						this.qcbtnwidth = this.$refs.xxdrawer.offsetWidth
					};
				})
				if (this.noread >= 1) {
					this.axios.post('/admin/pc/sys/allRead', {
						source: 1
					}, {
						token: true
					}).then(res => {
						this.noread = ''
					})
				}
			},

			//获取当前选中的菜单
			getSelectItem(arr, keyArr){
				let keyArr2=[...keyArr]
				if(keyArr2.length == 0)return null;
				let key = keyArr2.splice(0, 1)[0];
				let result = null;

				for(let item of arr){
					if(item.pathname === key){
						result = item;
						break;
					}
				}

				if(result == null)return null;

				if(keyArr2.length == 0){
					return result;
				}else{
					return this.getSelectItem(result.child, keyArr2);
				}
			}
		},
	};
</script>

<style lang='scss'>
	.mbx_text {
		font-size: 20px;
		font-weight: 600;
	}

	.opicon {
		cursor: pointer;
	}

	.aside_icon {
		color: #fff;
		font-size: 25px;
	}

	.aside_icon_out {
		margin-left: 50px;
	}

	.aside_on {
		transform: rotate(180deg);
		transition: all .3s;
	}

	.aside_off {
		transform: rotate(0deg);
		transition: all .3s;
	}

	.toplogobox {
		height: 100%;

	}

	.win_b {
		margin-right: 15px;
		cursor: pointer;

		.win_text {
			padding-right: 15px;
			border-right: 1px solid #e9ecf7;
		}
	}

	.win_b:hover {
		.win_text {
			color: #ff9f24;
		}
	}

	.h_right {
		margin-right: 52px;

		.el-menu.el-menu--horizontal {
			border: none;
		}
	}

	.logos {
		height: 80%;

		img {
			height: 100%;
			display: block;
		}

		.logotext {
			font-weight: 600;
			margin-left: 10px;
			color: #252631;
			font-size: 25px;
		}
	}

	.xxicon {
		color: #fff;
		cursor: pointer;
		font-size: 25px;
	}

	.xx_b_title {
		font-size: 18px;
		text-align: center;

		i {
			cursor: pointer;
		}

	}

	.xx_out_b {
		height: 100%;
		position: relative;
		width: 100%;
		padding-bottom: 90px;
		overflow: auto;



		.l_item {
			padding: 15px;
			border-bottom: 1px solid #e0e0e0;

			.xx_cons {
				flex: 1;

				.nr {
					word-break: break-all;
				}

				.xx_time {
					margin-top: 5px;
				}
			}

			.xicon {
				width: 98px;
				text-align: center;

				.closeicon {
					font-size: 18px;
					cursor: pointer;
				}

			}
		}

		.qcbtn_b {
			position: fixed;
			bottom: 0px;
			padding: 28px 0;
			font-size: 18px;
			display: flex;
			justify-content: center;
			border-top: 1px solid #e0e0e0;
			background-color: #fff;

			.tbns {
				padding: 4px 15px;
				font-size: 15px;
				border: 1px solid #e0e0e0;
				border-radius: 4px;
				cursor: pointer;
				transition: all .4s;

			}

			.tbns:hover {
				border-color: #0078ff;
				color: #0078ff;
				transition: all .4s;
			}
		}
	}

	.cebian {
		height: calc(100% - 70px);
		ul.el-menu:first-child {
			padding-top: 20px !important;
		}
	}

	.top_ewm_b {
		width: 100%;

		img {
			width: 100%;
			display: block;
		}
	}

	.ewmtext {
		text-align: center;
		padding: 5px 0;
		font-size: 16px;
	}

	.ewmtext2 {
		text-align: center;
		font-size: 14px;
	}

	.mian_view {
		height: 100%;
	}
</style>